"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
async function settleAll(promises, 
// tslint:disable-next-line:no-any (no way to guarantee error typings)
errFn = err => err) {
    const intermediateResults = await Promise.all((promises || []).map(async (p, i) => {
        try {
            return { results: await p };
        }
        catch (err) {
            return { errors: await errFn(err, i) };
        }
    }));
    const settledPromises = { results: [], errors: [] };
    for (const result of intermediateResults) {
        for (const key in result) {
            // @ts-ignore typings line up, but typescript is hard pressed to agree
            settledPromises[key].push(result[key]);
        }
    }
    return settledPromises;
}
exports.settleAll = settleAll;
//# sourceMappingURL=settleAll.js.map